import React from 'react';
import { useParams } from 'react-router';

import { ICardMasksForm } from 'api/blacklists/types';
import { useRBAC } from 'hooks/useRBAC';
import { useGetMerchant } from 'queries/merchants';
import {
  useGetTransactionCard,
  useGetTransactionCustomer,
  useGetTransactionDetails,
} from 'queries/transactions';

export const useGetTransactionInitialData = () => {
  const { id = '' } = useParams();

  const { data: cardDetails } = useGetTransactionCard(id);
  const { data: customerDetails } = useGetTransactionCustomer(id);
  const { data: baseDetails } = useGetTransactionDetails(id);
  const { data: merchantInfo } = useGetMerchant(baseDetails?.basic?.merchantTerminalId);

  const { isFullAccess } = useRBAC();

  const initialValues = React.useMemo(
    () =>
      cardDetails && customerDetails && baseDetails && merchantInfo
        ? ({
            bin: cardDetails.cardBin,
            blockFullOrganization: isFullAccess,
            customerId: customerDetails.merchantCustomerId,
            lastFour: cardDetails.cardLast4,
            merchantId: merchantInfo?.merchantTerminalInfo?.merchantId || null,
            merchantTerminalIds: baseDetails.basic.merchantTerminalId
              ? [baseDetails.basic.merchantTerminalId]
              : [],
          } as ICardMasksForm)
        : undefined,
    [cardDetails, customerDetails, baseDetails, merchantInfo, isFullAccess],
  );

  return { initialValues, isLoading: !initialValues };
};
